import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Rating from "./Rating";

function TechnicalSkillProfile({ techSkill }) {
  if (techSkill.iplayme2Rating === undefined) {
    return null;
  }
  return (
    <div className="row" style={{ paddingLeft: "15px", paddingRight: "15px" }}>
      <div className="col-xs-4 item-profile">
        <p>
          <FormattedMessage id={`ENUM.Sport.${techSkill.sport}`} />
        </p>
      </div>
      <div className="col-xs-4 item-profile">
        <p>
          {techSkill.wins} - {techSkill.loses}
        </p>
        <p>
          <span className="header">
            <FormattedMessage id="WA.TechSkill.MatchRecord" />
          </span>
        </p>
      </div>
      <div className="col-xs-4 item-profile">
        <Rating rating={techSkill.iplayme2Rating} />
      </div>
    </div>
  );
}

TechnicalSkillProfile.propTypes = {
  techSkill: PropTypes.shape({
    iplayme2Rating: PropTypes.number,
    wins: PropTypes.number,
    loses: PropTypes.number,
  }),
  ratingSystems: PropTypes.arrayOf(
    PropTypes.shape({
      iplayme2Rank: PropTypes.number,
      systemCode: PropTypes.string,
      systemValue: PropTypes.string,
      sportType: PropTypes.string,
    })
  ),
};

TechnicalSkillProfile.defaultProps = {
  techSkill: {},
};

export default TechnicalSkillProfile;
